/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FavoritableType {
    PROPERTY_REPORT = 'property_report',
    MARKET_ANALYSIS = 'market_analysis',
    DATASET = 'dataset',
    RENT_ROLL = 'rent_roll',
}
